import React, { ReactNode } from 'react'
import { FullPageCenteredPageContent } from './LayoutComponents'
import { Error as _ErrorIcon } from '@styled-icons/material'
import styled from 'styled-components'

const ErrorIcon = styled(_ErrorIcon)`
  width: 100px;
  height: 100px;
`
ErrorIcon.displayName = 'ErrorIcon'

function ErrorMessage({ children }: { children?: ReactNode }) {
  return (
    <FullPageCenteredPageContent>
      <ErrorIcon />
      {children}
    </FullPageCenteredPageContent>
  )
}

export default ErrorMessage
